/**
 * Message catalogs are defined per screen, with English and Spanish side by side so they always
 * ship together (DESIGN 8). Strings use ICU MessageFormat: `{name}` placeholders, plurals
 * (`{count, plural, one {# person} other {# people}}`) and selects. Never concatenate.
 */
export type Catalog = Readonly<Record<string, string>>;

export interface Bilingual<K extends string> {
  readonly en: Readonly<Record<K, string>>;
  readonly es: Readonly<Record<K, string>>;
}

/** Declares a namespace: Spanish must provide exactly the English keys. */
export function defineMessages<const E extends Catalog>(
  en: E,
  es: { readonly [K in keyof E]: string },
): Bilingual<Extract<keyof E, string>> {
  return { en, es };
}
